<template>
  <ul class="topic-list">
    <li v-for="(topic, index) in topics" v-if="topic" :key="index" :class="[topic.isHotTopic?'active':'']">
      <router-link :to="'/track/'+topic.id">
        <h2>{{topic.topic}}</h2>
      </router-link>
      <div v-html="topic.introduce"></div>
    </li>
  </ul>
</template>

<script>
// import Topic from './topic'

export default {
  components: {
  },
  props: [
    'topics'
  ],
  data () {
    return {
      curTab: 0
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
  .topic-list
    display: flex
    width: 100%
    flex-wrap: wrap
    >li
      position: relative
      width: 363px
      height: 206px
      padding: 30px 18px 0 18px
      margin-right: 25px
      margin-bottom: 25px
      border: 1px solid #d6dce3
      overflow: hidden

      &:nth-child(3n)
        margin-right: 0

      &:hover
        box-shadow: 0 0 5px rgba(213, 225, 238, 1)

      >a
        color: #3e3a39
        display: block
        h2
          font-size: 20px
          color: #246bb0
          padding-bottom: 12px
          border-bottom: 1px solid #d6dce3
          display: -webkit-box
          /*! autoprefixer: ignore next */
          -webkit-box-orient: vertical
          -webkit-line-clamp: 1
          overflow: hidden
      >div
        margin-top: 12px
        text-align: justify
        font-size: 14px
        line-height: 26px
        color: #3e3a39
        display: -webkit-box
        /*! autoprefixer: ignore next */
        -webkit-box-orient: vertical
        -webkit-line-clamp: 4
        overflow: hidden
        p
          height: 104px
          font-size: 14px
          line-height: 26px
          color: #3e3a39
          display: -webkit-box
          /*! autoprefixer: ignore next */
          -webkit-box-orient: vertical
          -webkit-line-clamp: 4
          overflow: hidden
  .active
    &:after
      content: ''
      width: 36px
      height: 36px
      background-image: url(../../assets/hot-tag.png)
      background-size: 36px
      background-repeat: no-repeat
      background-position: center
      display: block
      position: absolute
      right: 0
      top: 0
</style>
